var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCheckEnvelope = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0166AA",
  d: "M.495 4.57 6.66.872a.67.67 0 0 1 .686 0l6.159 3.697a.33.33 0 0 1 .162.286v8.477A.667.667 0 0 1 13 14H1a.666.666 0 0 1-.667-.667V4.855a.33.33 0 0 1 .162-.286m1.172.852v7.245h10.667V5.42l-5.331-3.2zm5.373 3.71 3.53-2.975.86 1.02-4.38 3.691-4.474-3.687.848-1.029z"
})));
export default SvgCheckEnvelope;